import React, { useState, useCallback } from "react";
import { Row, Col, Collapse } from "antd";
import { useIntl } from "react-intl";

import Tracking from "../../tracking2";
import TitleText from "../../app/generic/titleText";
import ExternalLink from "../../app/generic/externalLink";
import TooltipButton from "../../app/generic/tooltipButton";
import { parseDateTime } from "../../../modules/consignmentFunctions";
import ConsignmentDateTime from "../../app/generic/consignmentDateTime";
import ConsignmentPrintModal from "../../consignmentList/consignmentPrintModal";

const { Panel } = Collapse;

const ConsignmentDetailInfo = ({ consignment }) => {
  const intl = useIntl();
  const [modalVisible, setModalVisible] = useState();
  const handlePrintClick = useCallback(() => {
    setModalVisible(true);
  }, []);

  return (
    <Row gutter={[0, 75]}>
      <Col>
        <Row type="flex" justify="center" align="middle" gutter={[0, 75]}>
          <Col xxl={{ offset: 3, span: 12 }} sm={{ offset: 0, span: 15 }}>
            <TitleText
              title={intl.formatMessage({
                id: "consignment.product",
                defaultMessage: "Produkt",
              })}
              text={consignment.product.name}
            />
            <TitleText
              title={intl.formatMessage({
                id: "consignment.code",
                defaultMessage: "Číslo zásilky",
              })}
              text={consignment.codes}
            />
            <TitleText
              title={intl.formatMessage({
                id: "consignment.sentDateTime",
                defaultMessage: "Datum odeslání",
              })}
              text={parseDateTime(consignment.sentDateTime)}
            />
            <TitleText
              title={intl.formatMessage({
                id: "consignment.sentByUser",
                defaultMessage: "Odesláno uživatelem",
              })}
              text={
                consignment.senderUser
                  ? `${consignment.senderUser.firstname} ${consignment.senderUser.lastname}`
                  : "--"
              }
              rightItem={
                <ConsignmentDateTime
                  hideText
                  intl={intl}
                  intlId="consignment.sentByDhl"
                  intlIdFreApi="consignment.freapi"
                  intlIdCancel="consignment.state.cancelled"
                  cancelled={consignment.cancelled}
                  operation={consignment.sentByDhl}
                  freApi={consignment.freApiConsignment}
                  cancelledUser={consignment.cancellerUser}
                  dateTime={parseDateTime(consignment.sentDateTime)}
                  defaultMessage="Zásilka byla odeslána do DHL zaměstnancem DHL."
                  defaultMessageFreApi="Zásilka byla odeslána do DHL skrze FREAPI."
                  defaultMessageCancel="Zásilka byla stornována objednatelem."
                />
              }
            />
            {consignment.proofOfDeliveryUrl && (
              <TitleText
                title={intl.formatMessage({
                  id: "consignment.pod",
                  defaultMessage: "POD zásilky",
                })}
                text={
                  <ExternalLink
                    id="messages.here"
                    defaultMessage="zde"
                    titleId="consignment.pod.show"
                    href={consignment.proofOfDeliveryUrl}
                    titleDefaultMessage="Kliknutím zobrazíte POD zásilky"
                  />
                }
              />
            )}
          </Col>
          <Col span={9}>
            <TooltipButton
              onClick={handlePrintClick}
              disabled={consignment.cancelled}
              text={intl.formatMessage({
                id: "messages.printOffer",
                defaultMessage: "Nabídka tisku",
              })}
            />
          </Col>
          <ConsignmentPrintModal
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            consignmentIds={[
              consignment.id === -1
                ? consignment.externalCode || consignment.internalCode
                : consignment.id,
            ]}
          />
        </Row>
        <Row type="flex" justify="center" align="middle" gutter={[0, 75]}>
          <Col xxl={18} sm={24}>
            <Collapse>
              <Panel
                key="1"
                header={intl.formatMessage({
                  id: "consignment.track",
                  defaultMessage: "Sledování zásilky",
                })}
              >
                <Tracking bigger consignmentCode={consignment.code} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ConsignmentDetailInfo;
